<template>
  <section>
    <AboutHistoryHeader />
    <AboutHistoryIntro />
    <AboutHistoryIndex />
  </section>
</template>

<script>
import * as partials from './partials'

export default {
  name: 'AboutHistory',
  components: { ...partials },
  provide() {
    return {
      wp: this.$wp.pages['about-history'] || {}
    }
  },
  mounted() {
    console.log('about-history', this.$wp.pages['about-history'])
  }
}
</script>
